import React from 'react';
import { useTheme } from '../../../theme';
import { CheckedInIcon } from '../Icons';
var CheckedInIconWrapper = function () {
    var theme = useTheme('ExtraBaggage').ExtraBaggage;
    return React.createElement("div", { className: theme.checkedInIcon }, CheckedInIcon);
};
export default CheckedInIconWrapper;
